import React, { useContext } from 'react';
import { HeroTemplate as HeroTemplateProps } from './types';
import { renderCTAOptions } from '../../../renderCTAOptions';
import { Typography, Box } from '@sezzle/sezzle-mui';
import { ScreenSizeConfiguratorContext } from '../../../ScreenSizeConfigurator';
import { StyledHeroTextContainer, StyledHeroTextButtonContainer, StyledHeroTextDescriptionContainer, StyledHeroTextButton } from './styles';

const HeroText = ({
  h1Header, h1HeaderFont, mobileCtas, buttonPlacementBelowSubcopy,
  bodyCopy1, bodyCopy2, bodyCopy3,
  bodyCopy1Font, bodyCopy2Font, bodyCopy3Font,
}: HeroTemplateProps) => {

  const { screenConfig } = useContext(ScreenSizeConfiguratorContext);

  const buttonWidth = (screenConfig.isMobile || screenConfig.isTablet) ? '100%' : '48%';

  h1HeaderFont = h1HeaderFont || 'SubHeadBoldSmall';
  bodyCopy1Font = bodyCopy1Font || 'BodyRegular';
  bodyCopy2Font = bodyCopy2Font || 'BodyRegular';
  bodyCopy3Font = bodyCopy3Font || 'BodyRegular';



  return (
    <Box data-component-type="hero-text" >
      <StyledHeroTextContainer container direction="column" alignItems="flex-start" >
        <Typography variant={h1HeaderFont} component='h1'>{h1Header}</Typography>
        {mobileCtas?.length !== 0 && !buttonPlacementBelowSubcopy
          && (
            <StyledHeroTextButtonContainer >
              {mobileCtas?.map((item, index) => (
                <StyledHeroTextButton key={index} sx={{ width: buttonWidth }}>
                  {renderCTAOptions(item?.sys?.contentType?.sys?.id || item?.contentfulContentType, item, true)}
                </StyledHeroTextButton>
              ))}
            </StyledHeroTextButtonContainer>
          )}
        <Box>

          <StyledHeroTextDescriptionContainer >
            {bodyCopy1
              && (
                <Typography variant={bodyCopy1Font}>{bodyCopy1}</Typography>
              )}
            {bodyCopy2
              &&
              <Typography variant={bodyCopy2Font}>{bodyCopy2}</Typography>
            }
            {bodyCopy3
              &&
              <Typography variant={bodyCopy3Font}>{bodyCopy3}</Typography>
            }
          </StyledHeroTextDescriptionContainer>

        </Box>
      </StyledHeroTextContainer>

      {mobileCtas?.length !== 0 && buttonPlacementBelowSubcopy
        && (
          <StyledHeroTextButtonContainer container spacing={1}>
            {mobileCtas?.map((item, index) => (
              <StyledHeroTextButton items key={index} sx={{ width: buttonWidth }}>
                {renderCTAOptions(item?.sys?.contentType?.sys?.id || item?.contentfulContentType, item, true)}
              </StyledHeroTextButton>
            ))}
          </StyledHeroTextButtonContainer>
        )}
    </Box>
  );
};

export default HeroText;
